<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import { elementDetails, elementInstance, roles, activityVersion, standaloneEdit, 
        loadingElementDetails, triggerNewDraftElementVersionCreation, draftElementDetails } from '../workspacesStore.js';
    import { selectedListItems, updateLocalRoles } from './utils.js';
    import { elementTabs } from '../tabStore.js';
    import { post } from '../../../utils.js';
    import { setActiveTab, toggleTabHide } from '../../TabView/TabView.svelte';
    import {get} from '../../../utils.js';
    import {
        addLocalNewDraftElementVersion,
    } from '../RoleSequenceList/utils.js';
    import {sgettext} from '../../../i18n.js';

    export let row = {};
    export let fix = false;
    export let showIcon = false;

    $: elementIsArchived = $elementDetails ? $elementDetails.archived : false;
    $: elementIsExpired = $elementDetails ? $elementDetails.archived : false;
    $: rowId = row ? row.id : 0;
    let isEditable = ($activityVersion ? $activityVersion.isEditable : false)

    let deleteElementInstanceApi = `${PATH_PREFIX}/sw/api/builder/elementinstance/delete/`;
    let getElementDetailViewApi = `${PATH_PREFIX}/sw/api/elements_database/element_from_instance/`;
    let elementVersionApiUrl = `${PATH_PREFIX}/sw/api/elements_database/elementversions/`;


    async function invalidHazadControlButtonClicked() {   
        //get selected Element Details        
        await getElementDetails();    
        //if element status is DRAFT
        if ($elementInstance.versions) {
            if ($elementInstance.versions[0].status != 'DRAFT') {
                await triggerNewDraftElementVersionCreation.set(true);
            }
            if (!elementIsArchived) {  
                if ($elementDetails.materialRisk) { // check if element has any material risk
                    if (!$elementDetails.materialRisk.valid) {
                        if (!$draftElementDetails)
                        {
                            await createNewDraftElementVersion();
                        }
                        elementTabs.set(toggleTabHide('material_risk', true, $elementTabs));
                        elementTabs.set(setActiveTab('material_risk', $elementTabs));
                    } else {
                        elementTabs.set(setActiveTab('edit', $elementTabs));
                    }
                } else {
                    elementTabs.set(setActiveTab('edit', $elementTabs));
                }
                //Need to add to solve scrolling problem first time when we click on fix button
                waitForElement('scrollHazardControl', function() {
                    let moveTo = document.getElementById('scrollHazardControl');
                    moveTo.scrollIntoView();
                });
            }
        }
    }

    function waitForElement(elementId, callBack) {
        window.setTimeout(function() {
            let element = document.getElementById(elementId);
            if (element) {
                callBack(elementId, element);
            } else {
                waitForElement(elementId, callBack);
            }
        }, 300);
    }

    async function createNewDraftElementVersion() {
        const payload = {
            elementId: $elementDetails.elementId,
            elementInstanceId: $elementInstance.id,
            name: $elementDetails.name,
            time: $elementDetails.time,
        };

        const url = `${elementVersionApiUrl}new_draft/`;
        const resp = await post(url, payload);

        if (resp.ok) {
            const json = await resp.json();
            const details = json;
            draftElementDetails.set(details);
            details.competencies = json.competencies.map((c) => ({
                id: c.competency,
                name: c.name,
            }));
            if (!$standaloneEdit) {
                updateLocalVersions(json);
            }
        }
    }


    function updateLocalVersions(newDraftVersion) {
        const newVersion = {
            id: newDraftVersion.eevId,
            elementId: newDraftVersion.elementId,
            status: 'DRAFT',
            version: {
                id: newDraftVersion.evId,
                number: newDraftVersion.version,
            },
        };
        elementInstance.update((ei) => {
            return {
                ...ei,
                versions: [
                    ...ei.versions,
                    newVersion
                ],
            };
        });
        roles.set(addLocalNewDraftElementVersion($roles, $elementInstance.roleId, $elementInstance.worksequenceId,
                $elementInstance.id, newVersion));
    }


    async function getElementDetails() {
        if ($elementInstance && $elementInstance.id) {
            const url = `${getElementDetailViewApi}${$elementInstance.id}/`;

            const response = await get(url);
            if (response.ok) {
                let updated = await response.json();
                elementDetails.set(updated);
            }
            loadingElementDetails.set(false);

        }
    }

    async function onInvalidRRRClick(row) {
        window.open(`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${$activityVersion.id}/worksequence/${row.work_sequence_id}/element_instance/${rowId}/`, '_blank')
    }

    async function onDelete(row) {
        if(row.element_id > 0){
            const payload = [{
                'role_id': row.role_id,
                'seq_id': row.work_sequence_id,
                'item_id': row.id
            }];

            const response = await post(deleteElementInstanceApi, payload);

            if (response.ok) {
                const json = await response.json();

                roles.set(updateLocalRoles($roles, json));
                selectedListItems.set([]);

                elementInstance.set(null);
                elementDetails.set(null);

                elementTabs.set(setActiveTab('view', $elementTabs));

            }
        }    
}
</script>
{#if row.invalid_reasons.length == 1}
        {#each row.invalid_reasons as invalid_reason}
            {#if fix}
                {#if row.expired === 'true'}
                    <button on:click="{() => onDelete(row)}" class="btn" title="{sgettext('$$REMOVE_SEQUENCE$$')}" style="padding:3px;"><i class="fas fa-trash text-secondary"></i></button>
                {:else if invalid_reason === 'RISK CHANGED' && !row.expired}
                    <button on:click="{() => invalidHazadControlButtonClicked(row)}" class="btn" title="{sgettext('$$EDIT_INVALID_RISK_CONTROL_PAIR$$')}" style="padding:0px;"><i class="fas fa-edit text-secondary"></i></button>
                {:else if invalid_reason === 'SAFETY_GLD' | invalid_reason === 'RRR'}
                    <a class="button" title="Edit RRR's in Builder View" href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${$activityVersion.id}/worksequence/${row.work_sequence_id}/element_instance/${rowId}/`} target="_blank" rel="noopener noreferrer"><i class="fas fa-edit text-secondary"></i></a>
                {:else if invalid_reason === 'ARCHIVED' || elementIsArchived || elementIsExpired}
                    <button on:click="{() => onDelete(row)}" class="btn" title="{sgettext('$$REMOVE_SEQUENCE$$')}" style="padding:3px;"><i class="fas fa-trash text-secondary"></i></button>
                {:else if (invalid_reason === 'RISK CHANGED' && row.expired) ||(invalid_reason === 'RRR' && row.expired)}
                    <button on:click="{() => onDelete(row)}" class="btn" title="{sgettext('$$REMOVE_SEQUENCE$$')}" style="padding:3px;"><i class="fas fa-trash text-secondary"></i></button>
                {/if}
            {:else if showIcon}
                {#if invalid_reason === 'RISK CHANGED' && !row.expired}
                    <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$INVALID_1$$')} - {sgettext('$$EDIT_INVALID_RISK_CONTROL_PAIR$$')}"
                    on:click= {isEditable ? invalidHazadControlButtonClicked(row) : ""}></i>
                {:else if invalid_reason === 'SAFETY_GLD'}
                    <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$LEGACY$$')} - {sgettext("$$EDIT_RRR_BUILDER_VIEW$$")}"
                    on:click= {isEditable ? onInvalidRRRClick(row) : ""}></i>
                {:else if invalid_reason === 'ARCHIVED'}
                    <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$ARCHIVED$$')} - {sgettext('$$REMOVE_SEQUENCE$$')}"
                    on:click= {isEditable ? onDelete(row) : ""}></i>
                {:else if invalid_reason === 'RRR'}
                    <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$RRR$$')} - {sgettext("$$EDIT_RRR_BUILDER_VIEW$$")}"
                    on:click= {isEditable ? onInvalidRRRClick(row) : ""}></i>
                {:else if (invalid_reason === 'RISK CHANGED' && row.expired) ||(invalid_reason === 'RRR' && row.expired)}
                    <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$ARCHIVED$$')} - {sgettext('$$REMOVE_SEQUENCE$$')}"
                    on:click= {isEditable ? onDelete(row) : ""}></i>
                {/if}
            {:else}
                {#if invalid_reason === 'RISK CHANGED' && !row.expired }
                    <span class="text-secondary">{sgettext('$$INVALID_1$$')}</span>
                {:else if invalid_reason === 'SAFETY_GLD'}
                    <span class="text-secondary">{sgettext('$$LEGACY$$')}</span>
                {:else if invalid_reason === 'ARCHIVED'}
                    <span class="text-secondary">{sgettext('$$ARCHIVED$$')}</span>
                {:else if invalid_reason === 'RRR' }
                    <span class="text-secondary">{sgettext('$$RRR$$')}</span>
                {:else if (invalid_reason === 'RISK CHANGED' && row.expired) ||(invalid_reason === 'RRR' && row.expired)}
                    <span class="text-secondary">{sgettext('$$ARCHIVED$$')}</span>
                {/if}
            {/if}
        {/each}
    {:else}
        {#if fix}
            {#if (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('RRR')) ||
            (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('LEGACY'))}
                <button on:click="{() => invalidHazadControlButtonClicked(row)}" class="btn" title="{sgettext('$$EDIT_INVALID_RISK_CONTROL_PAIR$$')}" style="padding:0px;"><i class="fas fa-edit text-secondary"></i></button>
            {:else if row.invalid_reasons.includes('SAFETY_GLD') && row.invalid_reasons.includes('RRR')}
                <a class="button" title='{sgettext("$$EDIT_RRR_BUILDER_VIEW$$")}' href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${$activityVersion.id}/worksequence/${row.work_sequence_id}/element_instance/${rowId}/`} target="_blank" rel="noopener noreferrer"><i class="fas fa-edit text-secondary"></i></a>
            {:else if (row.invalid_reasons.includes('RRR') && row.invalid_reasons.includes('ARCHIVED')) ||
                (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('ARCHIVED')) ||
                (row.invalid_reasons.includes('SAFETY_GLD') && row.invalid_reasons.includes('ARCHIVED'))}  
                <button on:click="{() => onDelete(row)}" class="btn" title="{sgettext('$$REMOVE_SEQUENCE$$')}" style="padding:3px;"><i class="fas fa-trash text-secondary"></i></button>
            {/if}
        {:else if showIcon}
            {#if (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('RRR')) ||
                (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('LEGACY'))}
                <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$INVALID_1$$')} - {sgettext('$$EDIT_INVALID_RISK_CONTROL_PAIR$$')}"
                on:click= {isEditable ? invalidHazadControlButtonClicked(row) : ""}></i>
            {:else if row.invalid_reasons.includes('RRR') && row.invalid_reasons.includes('SAFETY_GLD')}
                <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$RRR$$')} - {sgettext("$$EDIT_RRR_BUILDER_VIEW$$")}"
                on:click= {isEditable ? onInvalidRRRClick(row) : ""}></i>
            {:else if (row.invalid_reasons.includes('RRR') && row.invalid_reasons.includes('ARCHIVED')) ||
                (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('ARCHIVED')) ||
                (row.invalid_reasons.includes('SAFETY_GLD') && row.invalid_reasons.includes('ARCHIVED'))} 
                <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$ARCHIVED$$')} - {sgettext('$$REMOVE_SEQUENCE$$')}"
                on:click= {isEditable ? onDelete(row) : ""}></i>
            {/if}
        {:else}
            {#if (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('RRR')) ||
                (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('LEGACY'))}
                <span class="text-secondary">{sgettext('$$INVALID_1$$')}</span>
            {:else if row.invalid_reasons.includes('RRR') && row.invalid_reasons.includes('SAFETY_GLD')}
                <span class="text-secondary">{sgettext('$$RRR$$')}</span>
            {:else if (row.invalid_reasons.includes('RRR') && row.invalid_reasons.includes('ARCHIVED')) ||
                    (row.invalid_reasons.includes('RISK CHANGED') && row.invalid_reasons.includes('ARCHIVED')) ||
                    (row.invalid_reasons.includes('SAFETY_GLD') && row.invalid_reasons.includes('ARCHIVED'))}
                <span class="text-secondary">{sgettext('$$ARCHIVED$$')}</span>
            {/if}
        {/if}
    {/if}